module.exports = __webpack_public_path__ + "img/telefonos.f4a3c2c2.png";